// extracted by mini-css-extract-plugin
export default {"close":"Layout_close__ogJT9","show":"Layout_show__lV9Rj","active-link":"Layout_active-link__GpMc+","socialIcon":"Layout_socialIcon__1IWxK"};